import { __assign, __read, __values } from "tslib";
import { createSelector } from 'reselect';
import { getAirticketPriceToPay } from '../orderPrice/selectors';
export var getCheckoutState = function (state) { return state; };
export var getSubsidiesState = function (state) { return state.subsidies; };
export var getSubsidiesByPassengers = createSelector(getSubsidiesState, function (state) { return state.availableSubsidiesByPassengers; });
export var getSelectedSubsidies = createSelector(getSubsidiesState, function (state) { return state.selectedSubsidies; });
export var getIsSubsidiesLoading = createSelector(getSubsidiesState, function (state) { return state.isLoading; });
export var getIsSubsidiesModalOpen = createSelector(getSubsidiesState, function (state) { return state.resultsOpen; });
export var getInitialPrice = createSelector(getAirticketPriceToPay, function (airticketsPrice) { return airticketsPrice; });
export var getSubsidiesResults = createSelector(getSubsidiesState, function (state) { return state.subsidiesResultByPassengersSegments; });
export var getHasAvailableSubsidies = createSelector(getSubsidiesState, function (subsidiesState) {
    return Object.values(subsidiesState.availableSubsidiesByPassengers).some(function (availableSubsidy) { return !!availableSubsidy; });
});
export var getAvailableSubsidiesTypesByPassengers = createSelector(getSubsidiesByPassengers, function (subsidiesByPassengers) {
    var e_1, _a, e_2, _b;
    var result = {};
    try {
        for (var _c = __values(Object.entries(subsidiesByPassengers)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), passengerId = _e[0], passengerSubsidies = _e[1];
            result[passengerId] = [];
            var _loop_1 = function (availableSubsidy) {
                if (!result[passengerId].find(function (subsidy) { return subsidy.type === availableSubsidy.type; })) {
                    result[passengerId].push(availableSubsidy);
                }
            };
            try {
                for (var passengerSubsidies_1 = (e_2 = void 0, __values(passengerSubsidies)), passengerSubsidies_1_1 = passengerSubsidies_1.next(); !passengerSubsidies_1_1.done; passengerSubsidies_1_1 = passengerSubsidies_1.next()) {
                    var availableSubsidy = passengerSubsidies_1_1.value;
                    _loop_1(availableSubsidy);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (passengerSubsidies_1_1 && !passengerSubsidies_1_1.done && (_b = passengerSubsidies_1.return)) _b.call(passengerSubsidies_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
});
export var getSelectedSubsidiesPricesByPassengers = createSelector(getSubsidiesState, getSelectedSubsidies, getInitialPrice, function (subsidiesState, selectedSubsidies, initialPrice) {
    var e_3, _a, e_4, _b, e_5, _c, e_6, _d;
    var resultPriceByPassengers = {};
    try {
        for (var _e = __values(Object.entries(selectedSubsidies)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _g = __read(_f.value, 2), passengerId = _g[0], passengerSubsidies = _g[1];
            var resultPrice = {
                currency: initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.currency,
                amount: 0
            };
            resultPriceByPassengers[passengerId] = resultPrice;
            if (subsidiesState.subsidiesResultByPassengersSegments[passengerId]) {
                try {
                    for (var _h = (e_4 = void 0, __values(Object.entries(subsidiesState.subsidiesResultByPassengersSegments[passengerId]))), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var _k = __read(_j.value, 2), segmentSubsidies = _k[1];
                        try {
                            for (var segmentSubsidies_1 = (e_5 = void 0, __values(segmentSubsidies)), segmentSubsidies_1_1 = segmentSubsidies_1.next(); !segmentSubsidies_1_1.done; segmentSubsidies_1_1 = segmentSubsidies_1.next()) {
                                var subsidy = segmentSubsidies_1_1.value;
                                resultPrice.amount += subsidy.initialPrice.amount;
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (segmentSubsidies_1_1 && !segmentSubsidies_1_1.done && (_c = segmentSubsidies_1.return)) _c.call(segmentSubsidies_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
            var _loop_2 = function (selectedSubsidy) {
                var e_7, _l;
                var passengerAvailableSubsidies = subsidiesState.subsidiesResultByPassengersSegments[passengerId];
                try {
                    for (var _m = (e_7 = void 0, __values(Object.entries(passengerAvailableSubsidies))), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var _p = __read(_o.value, 2), subsidySegmentId = _p[0], availableSubsidy = _p[1];
                        if (selectedSubsidy.segmentId === subsidySegmentId) {
                            var relatedAvailableSubsidy = availableSubsidy.find(function (subsidy) { return selectedSubsidy.subsidyId === subsidy.id; });
                            if (relatedAvailableSubsidy) {
                                resultPrice.amount -= relatedAvailableSubsidy.discount.amount;
                            }
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_l = _m.return)) _l.call(_m);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            };
            try {
                for (var passengerSubsidies_2 = (e_6 = void 0, __values(passengerSubsidies)), passengerSubsidies_2_1 = passengerSubsidies_2.next(); !passengerSubsidies_2_1.done; passengerSubsidies_2_1 = passengerSubsidies_2.next()) {
                    var selectedSubsidy = passengerSubsidies_2_1.value;
                    _loop_2(selectedSubsidy);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (passengerSubsidies_2_1 && !passengerSubsidies_2_1.done && (_d = passengerSubsidies_2.return)) _d.call(passengerSubsidies_2);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return resultPriceByPassengers;
});
export var getSelectedSubsidiesPricesByPassengersFactory = function (priceType) {
    return createSelector(getSubsidiesState, getSelectedSubsidies, getInitialPrice, function (subsidiesState, selectedSubsidies, initialPrice) {
        var e_8, _a, e_9, _b;
        var resultPriceByPassengers = {};
        try {
            for (var _c = __values(Object.entries(selectedSubsidies)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), passengerId = _e[0], passengerSubsidies = _e[1];
                var resultPrice = {
                    currency: initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.currency,
                    amount: 0
                };
                resultPriceByPassengers[passengerId] = resultPrice;
                var _loop_3 = function (selectedSubsidy) {
                    var e_10, _f;
                    var passengerAvailableSubsidies = subsidiesState.subsidiesResultByPassengersSegments[passengerId];
                    try {
                        for (var _g = (e_10 = void 0, __values(Object.entries(passengerAvailableSubsidies))), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var _j = __read(_h.value, 2), subsidySegmentId = _j[0], availableSubsidy = _j[1];
                            if (selectedSubsidy.segmentId === subsidySegmentId) {
                                var relatedAvailableSubsidy = availableSubsidy.find(function (subsidy) { return selectedSubsidy.subsidyId === subsidy.id; });
                                if (relatedAvailableSubsidy) {
                                    resultPrice.amount += relatedAvailableSubsidy[priceType].amount;
                                }
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                };
                try {
                    for (var passengerSubsidies_3 = (e_9 = void 0, __values(passengerSubsidies)), passengerSubsidies_3_1 = passengerSubsidies_3.next(); !passengerSubsidies_3_1.done; passengerSubsidies_3_1 = passengerSubsidies_3.next()) {
                        var selectedSubsidy = passengerSubsidies_3_1.value;
                        _loop_3(selectedSubsidy);
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (passengerSubsidies_3_1 && !passengerSubsidies_3_1.done && (_b = passengerSubsidies_3.return)) _b.call(passengerSubsidies_3);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_8) throw e_8.error; }
        }
        return resultPriceByPassengers;
    });
};
export var getHasSelectedSubsidies = createSelector(getSelectedSubsidies, function (selectedSubsidies) {
    return Object.values(selectedSubsidies).some(function (subsidies) { return subsidies.length > 0; });
});
export var getTotalSelectedSubsidiesPrices = createSelector(getInitialPrice, getSelectedSubsidiesPricesByPassengersFactory('discount'), function (initialPrice, discountByPassengers) {
    var e_11, _a;
    var totalPrice = __assign({}, initialPrice);
    try {
        for (var _b = __values(Object.values(discountByPassengers)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var passenger = _c.value;
            totalPrice.amount -= passenger.amount;
            totalPrice.currency = passenger.currency;
        }
    }
    catch (e_11_1) { e_11 = { error: e_11_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_11) throw e_11.error; }
    }
    return totalPrice;
});
